// Description: DynamicButton to be used on the platform that will re-render when the user call the backend
// Updated: 14/08/2025
// Author: Simon Franklin

// React
import React, { useEffect, useState } from 'react'

// Material UI Components
import { Button } from '@mui/material'

// Render Your Component
const DynamicButton = ({ variant, text, handleFunction, style, loadingText }) => {
    const [loading, setLoading] = useState(false);

    const handleClick = async () => {
        setLoading(true);

        try {
            await handleFunction();
        } catch (error) {
            console.error('Erro ao buscar dados da API:', error);
            throw new Error('Erro ao buscar dados da API');
        } finally {
            setLoading(false);
        }
    }

    return (
        <Button variant={variant} disabled={loading} sx={style} onClick={async() => await handleClick()}>
            {loading === true && loadingText ? loadingText : text}
        </Button>
    )
}

export default DynamicButton